import Logo from "./assets/image/mobile/img_coline_info_007_3.png";

export const CoLineBackground = {
  // background: `rgb(15, 189, 133)`,
  width: "100vw",
  height: "100vh",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
};

export const CoLineRedirect = {
  cursor: "pointer",
};

export const ImgWrap = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  overflow: "hidden",
};

export const Img = {
  width: "100%",
  height: "100%",
  cursor: "pointer",
};
